<template>
    <div class="genome-info-wrapper">
      <div class="genome-heading">Genome Info</div>
      <div><span class="genome-info-label">MSDB ID: </span><span class="genome-info-value">{{ info.OrgInfo.MSDBID }}</span></div>
      <div><span class="genome-info-label">Genome Size: </span><span class="genome-info-value">{{ info.GenomeInfo.GenomeSize | exponentiateBases }}</span></div>
      <div><span class="genome-info-label">GC%: </span><span class="genome-info-value">{{ info.GenomeInfo.GC }}</span></div>
      <div><span class="genome-info-label">Common Name(s): </span><span class="genome-info-value">{{ info.OrgInfo.CommonName }}</span></div>
      <div><span class="genome-info-label">Assembly Level: </span><span class="genome-info-value">{{ info.OrgInfo.AssemblyLevel }}</span></div>
      <div><span class="genome-info-label">Assembly Source: </span><span class="genome-info-value">{{ info.OrgInfo.Source }}</span></div>
      <div><span class="genome-info-label">Assembly Build: </span><span class="genome-info-value">{{ info.OrgInfo.Build }}</span></div>
      <div><span class="genome-info-label">Gene Annotation: </span><span class="genome-info-value">{{ info.OrgInfo.Annotation === 'Y' ? 'Available' : 'Not Available' }}</span></div>
      <div><span class="genome-info-label">Taxonomy ID: </span><span class="genome-info-value">{{ info.OrgInfo.TaxID }}</span></div>
      <div><span class="genome-info-label">Kingdom: </span><span class="genome-info-value">{{ info.OrgInfo.Kingdom }}</span></div>
      <div><span class="genome-info-label">Group: </span><span class="genome-info-value">{{ info.OrgInfo.Group }}</span></div>
      <div><span class="genome-info-label">SubGroup: </span><span class="genome-info-value">{{ info.OrgInfo.SubGroup }}</span></div>
    </div>
</template>

<script>
export default {
  name: 'SpeciesGenomeInfoCard.vue',
  props: {
    info: Object,
    index: Number
  },
  filters: {
    allCaps (string) {
      if (!string) {
        return
      }
      return string.toUpperCase()
    },
    exponentiateBases (num) {
      if (!num) {
        return
      }
      let base = parseInt(num)
      if (base < 1000) {
        return `${base}bp`
      } else if (base < 1000000) {
        return `${(base/1000).toFixed(2)} Kb`
      } else if (base < 1000000000) {
        return `${(base/1000000).toFixed(2)} Mb`
      } else {
        return `${(base/1000000000).toFixed(2)} Gb`
      }
    }
  }
}
</script>

<style scoped>
div.genome-info-wrapper {
  min-width: 250px;
}

div.genome-info-wrapper div {
  padding: 5px;
  border-bottom: 1px solid #dcdcdc;
}

div.genome-heading {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}

span.genome-info-value {
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
  font-size: 1.2em;
  text-align: left;
}

span.genome-info-label {
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
  font-size: 1.2em;
  text-align: left;
  font-weight: bold;
}
</style>


